module.exports = __webpack_public_path__ + "lang/sk.json";


//////////////////
// WEBPACK FOOTER
// ./lang/sk.json
// module id = 83
// module chunks = d-game